<template>
  <transition
    enter-active-class="transition duration-300 ease-out transform"
    enter-class="scale-95 opacity-0"
    enter-to-class="scale-100 opacity-100"
    leave-active-class="transition duration-150 ease-in transform"
    leave-class="scale-100 opacity-100"
    leave-to-class="scale-95 opacity-0"
  >
    <div
      v-if="feedPopup"
      class="
        flex
        items-center
        justify-center
        fixed
        left-0
        bottom-0
        w-full
        h-full
      "
      style="background-color: #00000099"
    >
      <div class="bg-white rounded-lg w-144">
        <div class="flex flex-col items-start p-4">
          <div class="flex items-center w-full">
            <div class="text-gray-900 font-bold text-lg">Send DM</div>
            <div @click="handleCloseDmPop" class="ml-auto">
              <closeIcon />
            </div>
          </div>
          <hr class="w-full my-3" />
          <textarea
            class="textarea h-40 textarea-bordered w-full mb-1"
            placeholder="Message"
            required
            name="message"
            v-model="message"
          />
          <!-- <label
            class="cursor-pointer label mt-2 justify-start"
            style="width: fit-content"
          >
            <input
              type="checkbox"
              checked="sendnotification"
              class="checkbox checkbox-primary"
              v-model="addPoll"
            />
            <span class="label-text text-lg ml-3">Add Poll</span>
          </label> -->
          <!-- <div v-if="addPoll" class="w-full">
            <section class="flex items-center">
              <div class="w-full flex form-control">
                <input
                  type="text"
                  placeholder="Option 1"
                  class="input input-bordered mb-2 mt-2"
                  required
                  name="title"
                  v-model="firstOption"
                />
              </div>
              <select v-model="selectFirst" class="select select-bordered ml-8">
                <option disabled="disabled" value="">
                  Pick Audience Segment
                </option>
                <option value="create_segment">Crete new Segment</option>
                <option
                  v-for="(item, index) in segmentOnly"
                  :value="item._id"
                  :key="index"
                >
                  {{ item.title.slice(0, 30)
                  }}{{ item.title.length > 30 ? '...' : '' }}
                </option>
              </select>
            </section>
            <section class="flex items-center">
              <div class="w-full flex form-control">
                <input
                  type="text"
                  placeholder="Option 2"
                  class="input input-bordered mb-2 mt-2"
                  required
                  name="title"
                  v-model="secondOption"
                />
              </div>
              <select
                v-model="selectSecond"
                class="select select-bordered ml-8"
                required
              >
                <option disabled="disabled" value="">
                  Pick Audience Segment
                </option>
                <option value="create_segment">Crete new Segment</option>
                <option
                  v-for="(item, index) in segmentOnly"
                  :value="item._id"
                  :key="index"
                >
                  {{ item.title.slice(0, 30)
                  }}{{ item.title.length > 30 ? '...' : '' }}
                </option>
              </select>
            </section>
            <section class="flex items-center">
              <div class="w-full flex form-control">
                <input
                  type="text"
                  placeholder="Option 3"
                  class="input input-bordered mb-2 mt-2"
                  required
                  name="title"
                  v-model="thirdOption"
                />
              </div>
              <select
                v-model="selectThird"
                class="select select-bordered ml-8"
                required
              >
                <option disabled="disabled" value="">
                  Pick Audience Segment
                </option>
                <option value="create_segment">Crete new Segment</option>
                <option
                  v-for="(item, index) in segmentOnly"
                  :value="item._id"
                  :key="index"
                >
                  {{ item.title.slice(0, 30)
                  }}{{ item.title.length > 30 ? '...' : '' }}
                </option>
              </select>
            </section>
          </div> -->
          <hr class="w-full my-3" />
          <div class="ml-auto">
            <button
              :disabled="message.trim() === '' && dmLimit <= dmSentToday"
              class="btn btn-primary"
              @click="SendConfirmed"
            >
              Send
            </button>
            <button class="btn btn-outline ml-3" @click="handleCloseDmPop">
              Cancel
            </button>
          </div>
          <hr class="w-full my-3" />
          <h5 class="text-gray-700 text-base mb-0 italic">
            Use ${firstName} to have the platform personalize your message.
          </h5>
          <h5 class="text-gray-700 text-base italic">
            Use 2 empty lines to have the platform split messages to each
            user
          </h5>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import store from '@/store';
import admin from '@/services/admin';
import utils from '@/services/utils';
import closeIcon from '../icons/closeIcon.vue';

export default {
  name: 'SendMessageModal',
  props: [
    'newCourseModal',
    'dmstudents',
    'segmentOnly',
    'handlePopups',
    'feedPopup',
    'closeDMModal',
  ],
  components: {
    closeIcon,
  },
  watch: {
    selectSecond(val) {
      if (val === 'create_segment') {
        this.handlePopups();
        this.selectSecond = '';
      }
    },
    selectFirst(val) {
      if (val === 'create_segment') {
        this.handlePopups();
        this.selectFirst = '';
      }
    },
    selectThird(val) {
      if (val === 'create_segment') {
        this.handlePopups();
        this.selectThird = '';
      }
    },
  },
  data() {
    return {
      message: '',
      firstOption: '',
      secondOption: '',
      thirdOption: '',
      selectFirst: '',
      selectSecond: '',
      selectThird: '',
      addPoll: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.userDetails;
    },
    dmSentToday() {
      return this.$store?.state?.userDetails?.dmDetails?.dmLimit;
    },
    dmLimit() {
      return this.$store?.state?.userDetails?.myAccess?.dmLimit;
    },
  },
  methods: {
    async SendConfirmed() {
      store.commit('toggleLoading', true);
      let poleOption = [];
      if (this.addPoll) {
        if (
          (this.firstOption && !this.selectFirst) ||
          (!this.firstOption && this.selectFirst)
        ) {
          utils.setStatusMsg(
            this,
            'Please select first segment or enter title',
          );
          store.commit('toggleLoading', false);
          return;
        }
        if (
          (!this.secondOption && this.selectSecond) ||
          (this.secondOption && !this.selectSecond)
        ) {
          utils.setStatusMsg(
            this,
            'Please select second segment or enter title',
          );
          store.commit('toggleLoading', false);
          return;
        }
        if (
          (!this.thirdOption && this.selectThird) ||
          (this.thirdOption && !this.selectThird)
        ) {
          utils.setStatusMsg(
            this,
            'Please select third segment or enter title',
          );
          store.commit('toggleLoading', false);
          return;
        }
        poleOption = [
          {
            buttonText: this.firstOption,
            segmentId: this.selectFirst,
          },
          {
            buttonText: this.secondOption,
            segmentId: this.selectSecond,
          },
          {
            buttonText: this.thirdOption,
            segmentId: this.selectThird,
          },
        ];
      }
      const newMssg = this.message.split(/\r?\n\n\n/).filter((el) => el !== '');
      const data = {
        recieverIds: this.dmstudents,
        message: newMssg,
        isPoll: this.addPoll,
        poleOption,
      };

      await admin
        .sendDMCrone(data)
        .then((data1) => {
          store.commit('toggleLoading', false);
          console.log(data1);
          utils.setStatusMsg(this, data1.message);
          this.feedPopup = false;
        })
        .catch((error) => {
          store.commit('toggleLoading', false);
          utils.setStatusMsg(this, error?.response?.data?.message || 'something went wrong');
          console.log(error);
          this.feedPopup = false;
        });
      this.message = '';
      this.firstOption = '';
      this.secondOption = '';
      this.thirdOption = '';
      this.selectFirst = '';
      this.selectSecond = '';
      this.selectThird = '';
      this.addPoll = false;
    },
    handleCloseDmPop() {
      this.closeDMModal();
      this.message = '';
      this.firstOption = '';
      this.secondOption = '';
      this.thirdOption = '';
      this.selectFirst = '';
      this.selectSecond = '';
      this.selectThird = '';
      this.addPoll = false;
    },
  },
};
</script>
